import { render, staticRenderFns } from "./GmCard.vue?vue&type=template&id=28721a6f&"
import script from "./GmCard.vue?vue&type=script&lang=js&"
export * from "./GmCard.vue?vue&type=script&lang=js&"
import style0 from "./GmCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports